module.exports = __webpack_public_path__ + "img/icon-settings-active.dfe2e640.svg";